import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import isEmpty from "lodash/isEmpty";
import { pick } from "lodash";

// Components
import ImageUploader from "../../utils/ImageUploader";
import ErrorWrap from "../../utils/error-success/ErrorWrap";
import SuccessWrap from "../../utils/error-success/SuccessWrap";
import Button from "../../utils/Button";

// State
import { getBanners } from "../../../store/actions/banners";
import { userTokenUpdate } from "../../../store/actions/user";

// Utils
import { deleteTempImages } from "../../../utils/uploadHelpers";

class BannerNew extends Component {
	constructor(props) {
		super(props);
		this.state = {
			errors: {},
			updateSuccess: "",
			updateLoading: false,
			updateErrors: {},
			data: {
				href: "",
				alt: ""
			},
			promiseCollection: []
		};
	}

	handleInputChange(event) {
		event.preventDefault();
		this.setState({
			data: {
				...this.state.data,
				[event.target.id]: event.target.value
			}
		});
	}

	handleKeyPress(event, item_id) {
		if (event.key === "Enter") {
			this.handleSubmit();
		}
	}

	handleSubmit = () => {
		// Set the state to let everything know that submitting is happening
		// We need to wait for this to actually complete and utilize the callback so any uploaders
		// actually know that they should begin uploading
		this.setState(
			{
				updateSuccess: "",
				updateErrors: {},
				updateLoading: true
			},
			() => {
				// Wait until all uploader promises have completed
				Promise.all(this.state.promiseCollection)
					.then(resolves => {
						// console.log('ok parent:', resolves)

						this.setState({
							promiseCollection: []
						});

						this.completeSubmit(resolves);
					})
					.catch(err => {
						// console.log('err parent:', err)
						this.setState({
							updateLoading: false,
							promiseCollection: []
						});
					});
			}
		);
	};

	completeSubmit(resolves) {
		const { user } = this.props;

		// Get chunked image results for both file types
		const full = resolves.filter(obj => {
			if (!obj) return false;
			return obj[0].type === "full";
		})[0];
		const mobile = resolves.filter(obj => {
			if (!obj) return false;
			return obj[0].type === "mobile";
		})[0];

		// Put request data together
		const data = {
			...this.state.data,
			image_full: !!full ? pick(full[0].results, ["dirName", "filename"]) : {},
			image_mobile: !!mobile ? pick(mobile[0].results, ["dirName", "filename"]) : {}
		};

		// We might need to delete these later
		const uploadedUrls = [];
		if (!!data.image_full) uploadedUrls.push(data.image_full);
		if (!!data.image_mobile) uploadedUrls.push(data.image_mobile);

		const token = user.token;
		const AUTH_HEADER = { Authorization: process.env.REACT_APP_SITE_KEY + ":Bearer " + token };
		return axios
			.post(process.env.REACT_APP_API_URL + "banners/chunked", data, { headers: AUTH_HEADER })
			.then(response => {
				if (!!response.data.token) {
					this.props.userTokenUpdate("admin", response.data.token);
				}

				if (
					response.status !== 200 ||
					(response.data.status && response.data.status !== 200)
				) {
					this.setState({
						updateLoading: false,
						updateErrors: !isEmpty(response.data.errors)
							? response.data.errors
							: { general: response.data.message }
					});

					deleteTempImages(uploadedUrls, this.props.user.token).catch(err => {
						console.log(err);
					});
				} else {
					// Reset state
					this.setState({
						updateLoading: false,
						updateSuccess: response.data.message,
						data: {
							href: "",
							alt: ""
						}
					});

					this.props.userTokenUpdate("admin", response.data.token);

					// Get banners
					this.props.getBanners();
				}
			})
			.catch(err => {
				if (err.response) {
					this.setState({
						updateLoading: false,
						updateErrors: {
							general: err.response.data.error
								? err.response.data.error
								: err.response.data.message
						}
					});
				} else {
					this.setState({
						updateLoading: false,
						updateErrors: { general: err.message }
					});
				}

				deleteTempImages(uploadedUrls, this.props.user.token).catch(err => {
					console.log(err);
				});
			});
	}

	render() {
		const { updateErrors, data, updateLoading, updateSuccess } = this.state;

		return (
			<div className="mb1">
				{updateSuccess && <SuccessWrap animate={1}>{updateSuccess}</SuccessWrap>}

				<div className="form-field grouped-field new-banner">
					<div>
						{updateErrors.full && (
							<ErrorWrap animate={1}>{updateErrors.full}</ErrorWrap>
						)}
						<ImageUploader
							loading={updateLoading}
							clear={!!updateSuccess}
							required={true}
							textLarge={"Full Size"}
							textSmall={"(1400 x 450)"}
							type={"full"}
							uploadAssetType={"banner"}
							addPromise={promise => this.state.promiseCollection.push(promise)}
						/>

						{updateErrors.mobile && (
							<ErrorWrap animate={1}>{updateErrors.mobile}</ErrorWrap>
						)}
						<ImageUploader
							loading={updateLoading}
							clear={!!updateSuccess}
							required={false}
							textLarge={"Mobile"}
							textSmall={"(320 x 298)"}
							type={"mobile"}
							uploadAssetType={"banner"}
							addPromise={promise => this.state.promiseCollection.push(promise)}
						/>
					</div>

					{/* HREF */}
					<div className="form-field">
						<label>URL</label>

						{updateErrors.href && (
							<ErrorWrap animate={1}>{updateErrors.href}</ErrorWrap>
						)}
						<input
							type="text"
							id="href"
							value={data.href}
							placeholder="http://www.website.com"
							disabled={updateLoading}
							onKeyPress={e => this.handleKeyPress(e)}
							onChange={event => this.handleInputChange(event)}
						/>
					</div>

					{/* ALT TEXT */}
					<div className="form-field">
						<label>Alt</label>

						{updateErrors.alt && <ErrorWrap animate={1}>{updateErrors.alt}</ErrorWrap>}
						<input
							type="text"
							id="alt"
							value={data.alt}
							placeholder="Image Alternate Text"
							disabled={updateLoading}
							onKeyPress={e => this.handleKeyPress(e)}
							onChange={event => this.handleInputChange(event)}
						/>
					</div>

					<div className="btn_container">
						{updateErrors.general && (
							<ErrorWrap animate={1}>{updateErrors.general}</ErrorWrap>
						)}
						<Button
							text={"Add New"}
							clickHandler={this.handleSubmit}
							isLoading={updateLoading}
							{...this.props}
						/>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		user: state.user.admin
	};
};

export default connect(
	mapStateToProps,
	{ getBanners, userTokenUpdate }
)(BannerNew);



// WEBPACK FOOTER //
// ./src/components/admin/banners/BannerNew.js